
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState, useRef, useCallback } from "react";
import AkkhorLayout from "../layout/akkhor";
import AlertErrorForm from "../component/AlertErrorForm";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import SearchBoxModal from "../component/SearchBoxModal";
import Cropper from "react-easy-crop";
import men_teacher from "../assets/img/men-teacher.png"
import getCroppedImg from "../component/getCroppedImg";
import Spinner from "../component/Spinner";
import { Editor } from '@tinymce/tinymce-react';

export default function FormProfile() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const [imageSrc, setImageSrc] = useState(null); // ảnh gốc chọn từ input
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [nameFile, setNameFile] = useState(null);
    const [avatar, setAvatar] = useState(null);
    const [loadingImage, setLoadingImage] = useState(false)
    const [editorMounted, setEditorMounted] = useState(false);
    const editorRef = useRef(null);

    useEffect(() => {
        setEditorMounted(true); // chạy 1 lần khi mount
    }, []);

    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "learninghub_profiles/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                setDetail(res.data.data);
                                setAvatar(res.data.data.avatar)
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id]
    );

    const formik = useFormik({
        initialValues: detail ? detail : { user_id: '', description: '', user_id: null },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            user_id: Yup.string().trim().nullable().required('Vui lòng chọn nhân sự'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setTimeout(() => {
                if (avatar) {
                    values.avatar = avatar
                }
                values.description = editorRef.current?.getContent();
                setLoading(true)
                if (id > 0) {
                    Axios.put(URL_LIST_ALL + 'learninghub_profiles/' + id, values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.reload()
                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                } else {
                    // console.log(values);
                    Axios.post(URL_LIST_ALL + 'learninghub_profiles', values, user.config).then(res => {
                        setSubmitting(false);
                        setLoading(false)
                        if (res.data.status === "success") {
                            window.location.href = '/edit-learninghub_profiles/' + res.data.id

                        } else {
                            confirmAlert({
                                title: 'Lỗi',
                                message: res.data.message,
                                buttons: [{ label: 'OK' }]
                            });
                        }
                    }).catch(err => console.log(err));
                }
            }, 200);
            setSubmitting(false)
        },
    });

    // Hàm này lưu vùng crop tính theo pixel
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // Khi người dùng chọn file từ input
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageDataUrl = await readFile(file);
            setNameFile(file.name);
            setImageSrc(imageDataUrl);
            setShowCropper(true);
        }
    };

    // Hàm đọc file thành base64 để hiển thị cropper
    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.readAsDataURL(file);
        });
    }

    // Hàm crop và upload ảnh
    const onCropConfirm = async () => {
        try {
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
            const resizedBlob = croppedImageBlob; // hoặc resize tiếp nếu muốn

            let data = new FormData();
            data.append("type", "s3");
            data.append("name", "file");
            data.append("file", resizedBlob, nameFile); // đổi tên nếu muốn
            data.append("filetype", resizedBlob.type);

            setLoadingImage(true);
            Axios.post(URL_LIST_ALL + "fileupload", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: user.config.headers.Authorization,
                },
            })
                .then((res) => {
                    if (res.data.status === "success") {
                        const url = res.data.message;
                        if (url) {
                            setAvatar(url);
                            setLoadingImage(false);
                            setShowCropper(false);
                            setImageSrc(null);
                        }
                    } else {
                        setLoadingImage(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingImage(false);
                });
        } catch (e) {
            console.error(e);
        }
    };

    const convertYouTubeLinksToIframes = (html) => {
        return html.replace(
            /(?:<p>)?(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+))(?:<\/p>)?/g,
            (_, __, videoId) => `
            <div class="youtube-embed">
              <iframe 
                src="https://www.youtube.com/embed/${videoId}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>`
        );
    };
    const handleBlur = () => {
        const content = editorRef.current.getContent();
        const transformed = convertYouTubeLinksToIframes(content);
        if (content !== transformed) {
            editorRef.current.setContent(transformed);
        }
    };

    return (
        <AkkhorLayout idrole="learning_profile_manager">
            <div className="card height-auto mt-5">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Tạo Profile</h3>
                        </div>
                    </div>
                    <form className="new-added-form  form-info" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6 form-group">
                                <label>Chọn nhân sự <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['user_id']} name='user_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('user_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="user_id"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-12 col-sm-4 info-table table-responsive">
                                <h5>Ảnh đại diện:</h5>
                                <div className="avatar-group mt-3">
                                    <button type="button" className="btn p-0 btn-avatar" onClick={() => inputRef.current.click()}>
                                        {loadingImage ? (
                                            "Đang tải..."
                                        ) : avatar ? (
                                            <img src={avatar} alt="" className="avatar" />
                                        ) : (
                                            <img
                                                src={(men_teacher)}
                                                alt=""
                                                className="avatar"
                                            />
                                        )}
                                        <span className="fas fa-upload upload-icon"></span>
                                    </button>
                                    <input
                                        type="file"
                                        id="file"
                                        ref={inputRef}
                                        style={{ display: "none" }}
                                        accept="image/*"
                                        onChange={onFileChange}
                                    />

                                    {showCropper && (
                                        <>
                                            <div className="cropper-modal">
                                                <Cropper
                                                    image={imageSrc}
                                                    crop={crop}
                                                    zoom={zoom}
                                                    aspect={1}
                                                    onCropChange={setCrop}
                                                    onZoomChange={setZoom}
                                                    onCropComplete={onCropComplete}
                                                />

                                            </div>

                                        </>
                                    )}
                                </div>
                                {showCropper && <div className="w-100 mt-2">
                                    <button type="button" className="btn btn-sm btn-info" onClick={onCropConfirm}>Lưu</button>
                                    <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => {
                                        setShowCropper(false);
                                        setImageSrc(null);
                                    }}
                                    >
                                        Hủy
                                    </button>
                                </div>}
                            </div>
                            <div className="col-12 form-group mt-2">
                                <label>Mô tả</label>
                                {editorMounted && (
                                    <Editor
                                        apiKey="8vzg9hkuturhxampptav8epspf6gw56ny951lc2o70rehku4"
                                        onInit={(_, editor) => (editorRef.current = editor)}
                                        onBlur={handleBlur}
                                        initialValue={formik.values['description']}
                                        init={{
                                            height: 300,
                                            menubar: false,
                                            plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'],
                                            toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons charmap | code | link | help',
                                            placeholder: 'Nhập nội dung mô tả...',
                                        }}
                                    />
                                )}
                            </div>

                            <div className="col-12"></div>

                            <div className="col-12 form-group mt-5">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
